$(document).ready(function () {
  setInterval(function () {
    const awaitingImport = $('.js-invoice-check-imported');
    if (awaitingImport.length) {
      const invoiceIds = awaitingImport.map(function() {
        return $(this).data('id');
      }).get();

      $.ajax({
        method: 'post',
        url: $('#invoices').data('action'),
        data: {
          id_invoice: invoiceIds,
        },
        dataType: 'json',
        success: function (response) {
          awaitingImport.each(function () {
            const invoiceId = $(this).data('id');
            if (invoiceId in response) {
              $(this).replaceWith(response[invoiceId]);
            }
          });
        },
      });
    }
  }, 60000);
});
